import * as React from 'react';
import { Box, List, ListItem, ListItemButton, ListItemText, Typography, useTheme } from '@mui/material';
import { ExitToApp } from '@mui/icons-material';
import { SEARCH_RESULT_BUTTON_CLASS } from 'consts';

interface SearchResultListProps {
  title: string;
  data: any[];
  formatter: Function;
  onClick?: Function;
}

export const SearchResultList: React.FC<SearchResultListProps> = (props) => {
  const { title = '', data = [], formatter, onClick = () => {} } = props;
  const theme = useTheme();
  return (
    <Box sx={{ marginBottom: data.length ? 0 : 2 }}>
      <Typography
        sx={{
          borderBottom: 1,
          borderColor: theme.palette.primary.main,
          color: theme.palette.primary.main,
        }}
      >
        {title}
      </Typography>
      {data.length > 0 && (
        <List dense>
          {data.map((datum, index) => (
            <ListItem key={index} disableGutters disablePadding>
              <ListItemButton className={SEARCH_RESULT_BUTTON_CLASS} onClick={() => onClick(datum)}>
                <ListItemText primary={formatter(datum)} />
                <ExitToApp sx={{ color: theme.palette.text.secondary, fontSize: 18 }} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  );
};
